import React, { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import {
  createCourse,
  updateCourse,
} from "../../API/courses";
import Upload from "../../icons/upload";
import { IKImage, IKContext, IKUpload } from "imagekitio-react";
import "./addCourse.css";
import { ERROR_TOAST, INFO_TOAST, SUCCESS_TOAST } from "../../helpers/toasters";
import { imageKitPublicKey, imageKitUrlEndpoint, uri } from "../../helper";

interface handelFuncProps {
  handelClose: () => void;
  data?: {
    active: boolean;
    assessment: boolean;
    assessment_levels: string[];
    certification_levels: string[];
    course_completion: boolean;
    course_id: string;
    name: string;
    sample_report_card: string;
    sample_certificate: string;
    thumbnail: string;
    testimonials: string[];
    __v?: Number;
    _id: string;
  };
}

const fileTypes = ["JPG", "PNG", "GIF"];

export default function AddCourse(props: handelFuncProps) {

  useEffect(() => {
    if (props.data) {
      setReportCardUrl(props.data.sample_report_card || "");
      setReportFileName(props.data.sample_report_card ? "Existing Report Card" : "");
      setCertificateUrl(props.data.sample_certificate || "");
      setCertificateFileName(props.data.sample_certificate ? "Existing Certificate" : "");
      setThumbnailUrl(props.data.thumbnail || ""); // Initialize thumbnail url from props
      setThumbnailFileName(props.data.thumbnail ? "Existing Thumbnail" : "");
    }
  }, [props.data]);



  const [courseName, setcourseName] = useState<string>(props.data?.name || "");
  const [assessmentLevelCount, setAssessmentLevelCount] = useState<string>(props.data?.assessment_levels.length.toString() || "");
  const [certificateLevelCount, setCertificateLevelCount] = useState<string>(props.data?.certification_levels.length.toString() || "");

  const [Assesments, setAssesments] = useState<boolean>(
    props.data?.assessment || false
  );
  const [courseCompletion, setcourseCompletion] = useState<boolean>(
    props.data?.course_completion || false
  );
  const [status, setStatus] = useState<boolean>(props.data?.active || false);
  const [show, setShow] = useState<boolean>(false);
  const [List, setList] = useState<any>([]);
  const [myList, setMyList] = useState<any>([]);
  const [report, setReport] = useState("");
  const [certificate, setCertificate] = useState("");
  const [cardUploadId, setCardUploadId] = useState("");
  const [cardUploadedLogos, setCardUploadedLogos] = useState<string[]>([]);
  const [CertificateUrl, setCertificateUrl] = useState("");
  const [ReportCardUrl, setReportCardUrl] = useState("");
  const [ThumbnailUrl, setThumbnailUrl] = useState(""); // Added thumbnail URL state

  const [reportFileName, setReportFileName] = useState<string>("");
  const [certificateFileName, setCertificateFileName] = useState<string>("");
  const [thumbnailFileName, setThumbnailFileName] = useState<string>(""); // Added thumbnail filename state

  const handleRemoveReportCard = () => {
    setReportCardUrl("");
    setReportFileName("");
  };

  const handleRemoveCertificate = () => {
    setCertificateUrl("");
    setCertificateFileName("");
  };

  const handleRemoveThumbnail = () => { // Add handler for removing thumbnail
    setThumbnailUrl("");
    setThumbnailFileName("");
  };

  const handleClick = () => {
    return props.handelClose();
  };

  const onError = (e: any) => {
    
  };

  const onSuccess1 = (res: any) => {
    
    setCertificateFileName(res.name);
    setCardUploadedLogos((prev) => [res.thumbnailUrl, ...prev]);
    setCardUploadId(res.fileId);
    setCertificateUrl(res.url);
  };

  const onSuccess2 = (res: any) => {
    
    setReportFileName(res.name);
    setCardUploadedLogos((prev) => [res.thumbnailUrl, ...prev]);
    setCardUploadId(res.fileId);
    setReportCardUrl(res.url);
  };

  const onSuccessThumbnail = (res: any) => { // Add success handler for thumbnail upload
    
    setThumbnailFileName(res.name);
    setCardUploadedLogos((prev) => [res.thumbnailUrl, ...prev]);
    setCardUploadId(res.fileId);
    setThumbnailUrl(res.url);
  };

  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  const setData = (e: any) => {
    const choosen = List.filter((m: any) => m.name == e.target.value);
    setMyList(choosen);
    if (myList) {
      setShow(true);
    }
  };

  const showData = async () => {
    if (!courseName) {
      return INFO_TOAST("Please Enter a Course Name !");
    }

    if (!certificateLevelCount) {
      return INFO_TOAST("Please Enter Certification Levels !");
    }
    if (!assessmentLevelCount) {
      return INFO_TOAST("Please Enter Assessment Levels !");
    }

    if (!ThumbnailUrl) { // Validate thumbnail
      return INFO_TOAST("Please Upload a Course Thumbnail !");
    }

    const data = {
      name: courseName,
      active: status,
      assessment: Assesments,
      certification_levels: certificateLevelCount, // number
      assessment_levels: assessmentLevelCount,    // number
      sample_report_card: ReportCardUrl,
      sample_certificate: CertificateUrl,
      thumbnail: ThumbnailUrl, // Add thumbnail URL to the data
      course_completion: courseCompletion,
    };


    const result = await createCourse(data);
    if (result.message == "Course Created Successfully") {
      SUCCESS_TOAST("Course Created Successfully");
      handleClick();
    } else {
      ERROR_TOAST("something went wrong, Try again !");
    }
  };

  const generateLevelsArray = (count: number, prefix: string) =>
    Array.from({ length: count }, (_, i) => `${prefix} ${i + 1}`);

  const updateData = async () => {
    const data = {
      _id: props.data?._id,
      name: courseName,
      active: status,
      assessment: Assesments,
      certification_levels: generateLevelsArray(Number(certificateLevelCount), "Certificate Level"),
      assessment_levels: generateLevelsArray(Number(assessmentLevelCount), "Assessment Level"),
      sample_report_card: ReportCardUrl,
      sample_certificate: CertificateUrl,
      thumbnail: ThumbnailUrl, // Add thumbnail URL to update data
      course_completion: courseCompletion,
    };


    const result = await updateCourse(data);
    if (!result) {
      return ERROR_TOAST("Something Went Wrong !");
    }

    SUCCESS_TOAST("Course Updated Successfully !");
    handleClick();
  };

  return (
    <>
      <div className="addCourse">
        <div className="fullDesc">
          <div className="headerAC">
            <h2>{props.data ? "Update Course" : "Add Course"}</h2>
            <div
              className="top-svg"
              onClick={() => handleClick()}
              style={{ cursor: "pointer" }}
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 0C18.9782 0 22.7936 1.58035 25.6066 4.3934C28.4196 7.20644 30 11.0218 30 15C30 18.9782 28.4196 22.7936 25.6066 25.6066C22.7936 28.4196 18.9782 30 15 30C11.0218 30 7.20644 28.4196 4.3934 25.6066C1.58035 22.7936 0 18.9782 0 15C0 11.0218 1.58035 7.20644 4.3934 4.3934C7.20644 1.58035 11.0218 0 15 0ZM15 13.1807L11.5157 9.69643C11.2745 9.45518 10.9473 9.31964 10.6061 9.31964C10.2649 9.31964 9.93768 9.45518 9.69643 9.69643C9.45518 9.93768 9.31964 10.2649 9.31964 10.6061C9.31964 10.9473 9.45518 11.2745 9.69643 11.5157L13.1807 15L9.69643 18.4843C9.57697 18.6037 9.48221 18.7456 9.41757 18.9016C9.35292 19.0577 9.31964 19.225 9.31964 19.3939C9.31964 19.5629 9.35292 19.7301 9.41757 19.8862C9.48221 20.0423 9.57697 20.1841 9.69643 20.3036C9.81588 20.423 9.9577 20.5178 10.1138 20.5824C10.2699 20.6471 10.4371 20.6804 10.6061 20.6804C10.775 20.6804 10.9423 20.6471 11.0984 20.5824C11.2544 20.5178 11.3963 20.423 11.5157 20.3036L15 16.8193L18.4843 20.3036C18.6037 20.423 18.7456 20.5178 18.9016 20.5824C19.0577 20.6471 19.225 20.6804 19.3939 20.6804C19.5629 20.6804 19.7301 20.6471 19.8862 20.5824C20.0423 20.5178 20.1841 20.423 20.3036 20.3036C20.423 20.1841 20.5178 20.0423 20.5824 19.8862C20.6471 19.7301 20.6804 19.5629 20.6804 19.3939C20.6804 19.225 20.6471 19.0577 20.5824 18.9016C20.5178 18.7456 20.423 18.6037 20.3036 18.4843L16.8193 15L20.3036 11.5157C20.423 11.3963 20.5178 11.2544 20.5824 11.0984C20.6471 10.9423 20.6804 10.775 20.6804 10.6061C20.6804 10.4371 20.6471 10.2699 20.5824 10.1138C20.5178 9.9577 20.423 9.81588 20.3036 9.69643C20.1841 9.57697 20.0423 9.48221 19.8862 9.41757C19.7301 9.35292 19.5629 9.31964 19.3939 9.31964C19.225 9.31964 19.0577 9.35292 18.9016 9.41757C18.7456 9.48221 18.6037 9.57697 18.4843 9.69643L15 13.1807Z"
                  fill="#8E8EA1"
                />
              </svg>
            </div>
          </div>
          <div className="ac-border-top"></div>
          <div className="ad-body">
            <div className="previous-drop">
              <div className="dropdown">
                <label className="cat-hello" htmlFor="cname">
                  Course Name*
                </label>
                <input
                  type="text"
                  name="course_name"
                  value={courseName}
                  className="setSecond form-control dropdown-toggle"
                  onChange={(e) => setcourseName(e.target.value)}
                />
              </div>
              <div className="dropdown">
                <label className="cat-hello" htmlFor="cat">
                  Certification Levels*
                </label>
                <input
                  type="number"
                  className="form-select setThird"
                  value={certificateLevelCount}
                  onChange={(e) => setCertificateLevelCount(e.target.value)}
                />

              </div>
              <div className="dropdown">
                <label className="cat-hello" htmlFor="cat">
                  Assessment Levels*
                </label>
                <input
                  type="number"
                  className="form-select setThird"
                  value={assessmentLevelCount}
                  onChange={(e) => setAssessmentLevelCount(e.target.value)}
                />

              </div>
            </div>
            <div className="radios">
              <div>
                <label className="cat-hello mx-1" htmlFor="cat">
                  Assignment
                </label>
                <div className="radio-child ">
                  <label className="align-label px-2">
                    <input
                      type="radio"
                      name="choice-radio"
                      checked={Assesments}
                      onClick={() => setAssesments(true)}
                    />
                    <span className="mx-2"> Yes</span>
                  </label>
                  <label className="align-label px-4">
                    <input
                      type="radio"
                      name="choice-radio"
                      checked={!Assesments}
                      onClick={() => setAssesments(false)}
                    />
                    <span className="mx-2"> No</span>
                  </label>
                </div>
              </div>
              {/* radio 2 */}
              <div className="px-3">
                <label className="cat-hello mx-1" htmlFor="cat">
                  Course Completion
                </label>
                <div className="radio-child ">
                  <label className="align-label px-2">
                    <input
                      type="radio"
                      name="choice-radio2"
                      checked={courseCompletion}
                      onClick={() => setcourseCompletion(true)}
                    />
                    <span className="mx-2"> Yes</span>
                  </label>
                  <label className="align-label px-4">
                    <input
                      type="radio"
                      name="choice-radio2"
                      checked={!courseCompletion}
                      onClick={() => setcourseCompletion(false)}
                    />
                    <span className="mx-2"> No</span>
                  </label>
                </div>
              </div>
              {/* radio 3 */}
              <div className="mx-3">
                <label className="cat-hello mx-1" htmlFor="cat">
                  Status
                </label>
                <div className="radio-child ">
                  <label className="align-label px-2">
                    <input
                      type="radio"
                      name="choice3"
                      checked={status}
                      onClick={() => setStatus(true)}
                    />
                    <span className="mx-2"> Active</span>
                  </label>
                  <label className="align-label px-4">
                    <input
                      type="radio"
                      name="choice3"
                      checked={!status}
                      onClick={() => setStatus(false)}
                    />
                    <span className="mx-2"> Inactive</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="drag-drop-top-line"></div>

          {/* Thumbnail Upload Section */}
          <div className="upload-drag-drop d-flex justify-content-around">
            <div>
              <label htmlFor="thumbnail">Upload Course Thumbnail*</label>
              <IKContext
                publicKey={imageKitPublicKey}
                urlEndpoint={imageKitUrlEndpoint}
                authenticationEndpoint={`${uri}/card/auth`}
              >
                {ThumbnailUrl ? (
                  <div className="uploaded-preview">
                    <IKImage
                      src={ThumbnailUrl}
                      alt="Course Thumbnail"
                      className="uploaded-image"
                    />
                    <button
                      className="remove-btn"
                      onClick={handleRemoveThumbnail}
                    >
                      Remove
                    </button>
                  </div>
                ) : (
                  <div className="upload-area">
                    <IKUpload
                      fileName="course-thumbnail"
                      onError={onError}
                      onSuccess={onSuccessThumbnail}
                    />
                    <div className="upload-icon">
                      <Upload />
                    </div>
                    <div className="upload-text">
                      <p>Upload or drag & drop files here</p>
                      <p id="upload-text-second">JPG, PNG up to 10mb</p>
                    </div>
                  </div>
                )}
              </IKContext>
            </div>
          </div>

          <div className="drag-drop-top-line"></div>
          <div className="upload-drag-drop d-flex justify-content-around">
            {/* Report Card Upload */}
            <div>
              <label htmlFor="report-card">Upload Report Card</label>
              <IKContext
                publicKey={imageKitPublicKey}
                urlEndpoint={imageKitUrlEndpoint}
                authenticationEndpoint={`${uri}/card/auth`}
              >
                {ReportCardUrl ? (
                  <div className="uploaded-preview">
                    <IKImage
                      src={ReportCardUrl}
                      alt="Report Card"
                      className="uploaded-image"
                    />
                    <button
                      className="remove-btn"
                      onClick={handleRemoveReportCard}
                    >
                      Remove
                    </button>
                  </div>
                ) : (
                  <div className="upload-area">
                    <IKUpload
                      fileName="report-card"
                      onError={onError}
                      onSuccess={onSuccess2}
                    />
                    <div className="upload-icon">
                      <Upload />
                    </div>
                    <div className="upload-text">
                      <p>Upload or drag & drop files here</p>
                      <p id="upload-text-second">JPG, PNG up to 10mb</p>
                    </div>
                  </div>
                )}
              </IKContext>
            </div>

            {/* Certificate Upload */}
            <div>
              <label htmlFor="certificate">Upload Certificate</label>
              <IKContext
                publicKey={imageKitPublicKey}
                urlEndpoint={imageKitUrlEndpoint}
                authenticationEndpoint={`${uri}/card/auth`}
              >
                {CertificateUrl ? (
                  <div className="uploaded-preview">
                    <IKImage
                      src={CertificateUrl}
                      alt="Certificate"
                      className="uploaded-image"
                    />
                    <button
                      className="remove-btn"
                      onClick={handleRemoveCertificate}
                    >
                      Remove
                    </button>
                  </div>
                ) : (
                  <div className="upload-area">
                    <IKUpload
                      fileName="certificate"
                      onError={onError}
                      onSuccess={onSuccess1}
                    />
                    <div className="upload-icon">
                      <Upload />
                    </div>
                    <div className="upload-text">
                      <p>Upload or drag & drop files here</p>
                      <p id="upload-text-second">JPG, PNG up to 10mb</p>
                    </div>
                  </div>
                )}
              </IKContext>
            </div>
          </div>

          <div className="drag-drop-top-line"></div>
          <div className="down-buttons d-flex">
            <button
              className="create-button"
              onClick={() => {
                props.data ? updateData() : showData();
              }}
            >
              {props.data ? "Update Course" : "Create New Course"}
            </button>
            <button className="cancel-button" onClick={() => handleClick()}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}